export const DetailTag = ({
  icon,
  label,
}: {
  icon: React.ReactNode;
  label: string | number;
}) => (
  <div className="flex gap-2 items-center justify-center bg-primary-100 rounded-full px-3 py-1">
    {icon}
    <span className="text-primary-400 text-sm">{label}</span>
  </div>
);
